import * as types from './mutation-types'

export default {
    [types.LOAD_NOTES](state, data) {
      state.notes = data
    }
}
